import { useState, useContext } from 'react';
import { Award } from 'lucide-react';
import AuthContext from '../../../../../../../context/AuthContext';
import { useToast } from '../../../../../../../context/ToastContext';
import ConfirmationModal from '../../../../../../../components/ConfirmationModal';
import auditPlanService from '../../../../../../../services/audit_services/auditPlanService';

export default function UnachieveModal({ isOpen, onClose, planId, onSuccess }) {
  const { authTokens } = useContext(AuthContext);
  const { showError, showSuccess } = useToast();
  const [loading, setLoading] = useState(false);

  const handleUnachieve = async () => {
    setLoading(true);
    
    try {
      const result = await auditPlanService.unachieveAuditPlan(authTokens.access, planId);
      
      if (result.success) {
        showSuccess('Plan d\'audit désarchivé avec succès');
        onSuccess();
        onClose();
      } else {
        showError(result.error || 'Erreur lors du désarchivage du plan d\'audit');
      }
      setLoading(false);
    } catch (error) {
      console.error('Error unachieving audit plan:', error);
      showError('Erreur lors du désarchivage du plan d\'audit');
      setLoading(false);
    }
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleUnachieve}
      title="Désarchiver le plan d'audit"
      message="Êtes-vous sûr de vouloir retirer le statut archivé ? Cela changera le statut en clôturé."
      confirmText={loading ? 'Désarchivage...' : 'Désarchiver'}
      confirmButtonClass="bg-orange-600 hover:bg-orange-700"
      icon={<Award className="h-6 w-6 text-orange-600" />}
      loading={loading}
    />
  );
}
